import React, { FC } from 'react';

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import UserApplicationPageContainer from 'buyside/components/container/UserApplication/userApplicationPageContainer';

const UserApplicationPageRoot: FC<{
  appId: string;
  email: string;
  firstName: string;
  lastName: string;
}> = ({ appId, email, firstName, lastName }) => {
  return (
    <ErrorBoundary pageName="the user application">
      <UserApplicationPageContainer
        appId={appId || ''}
        email={email}
        firstName={firstName}
        lastName={lastName}
      />
    </ErrorBoundary>
  );
};

export default UserApplicationPageRoot;
